export default "/images/6bce4edbc28f1a3824df3249f505d9d1.png";